import React from 'react';

import pngImages from '../../Icons/png';

export const getIcon = commProd => {
  const iconName = commProd?.iconName ?? commProd?.custom_resources?.group?.icon;
  const path = iconName?.startsWith('http') ? iconName : pngImages[iconName];

  return <img className="img-icon" src={path} alt={commProd?.icon} />;
};